import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';

import { logger } from '@zep/core-logger';

import { ALLOWED_AI_FILE_EXTENSIONS } from '@/shared/features/ai-quiz-generation/constants';
import { useValidateFile } from '@/shared/hooks';
import { alertDialog } from '@/ui_v3';

export const useAiFileChange = () => {
  const { t } = useTranslation(['common']);
  const validate = useValidateFile({ service: 'ai' });
  return useCallback(
    async (fileInput: File) => {
      const fileExt = fileInput.name.split('.').pop()?.toLowerCase() || '';
      if (!ALLOWED_AI_FILE_EXTENSIONS.includes(fileExt)) {
        alertDialog.open({
          header: {
            title: t('common:common.validateFile.confirmFileExt'),
          },
          body: t('common:common.validateFile.possibleFileExt', {
            fileExt: ALLOWED_AI_FILE_EXTENSIONS.join(', '),
          }),
        });
        return;
      }

      logger.track('ai_문제생성_파일_업로드', {
        fileExtension: fileExt,
      });
      const isValid = validate(fileInput);
      if (!isValid) return;
      logger.track('ai_문제생성_파일_업로드_완료', {
        fileExtension: fileExt,
      });

      return fileInput;
    },
    [t, validate],
  );
};
